import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql, StaticQuery } from "gatsby"
import Linkify from "linkify-react"

const JobsPage = () => (
  <Layout noBanner={true}>
    <Seo title="Jobs" />
    <StaticQuery
      query={graphql`
        query JobsQuery {
          allSponsorsJson(filter: { rank: { ne: "bronze" } }) {
            edges {
              node {
                rank
                class
                entries {
                  name
                  image
                  url
                  width
                  title
                  jobDescription
                }
              }
            }
          }
        }
      `}
      render={data => {
        const groups = data.allSponsorsJson.edges.map(edge => edge.node)
        return (
          <section id="jobs" className="section-padding-top">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="section-title-header text-center">
                    <h1
                      className="section-title wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      Jobs
                    </h1>
                    <p className="wow fadeInDown" data-wow-delay="0.2s">
                      ジョブボード
                    </p>
                  </div>
                </div>
              </div>
              {groups.map((group, index) => group.entries.length > 0 && (
                <div className="row wow fadeInDown" data-wow-delay="0.3s">
                  <h2
                    className={"col-12 text-center sponsor-grade " + group.rank}
                  >
                    {group.rank.toUpperCase()}
                  </h2>
                  {group.entries
                    .filter(entry => entry["jobDescription"])
                    .map((entry, index) => {
                      const image = require("../images/sponsors/" + entry.image)
                      return (
                        <div className="col-12">
                          <div className="about-item mb-4">
                            <div className="row">
                              <div className="sponsors-logo col-12 col-md-5 col-lg-4 col-xl-3">
                                <a
                                  href={entry.url}
                                  target="_blank"
                                  rel="noopener"
                                >
                                  <img
                                    src={image.default}
                                    alt=""
                                    width={entry.width}
                                  />
                                </a>
                              </div>
                              <div className="about-text col-12 col-md-7 col-lg-8 col-xl-9">
                                <h3>
                                  <a
                                    href={entry.url}
                                    target="_blank"
                                    rel="noopener"
                                  >
                                    {entry.name}
                                  </a>
                                </h3>
                                <Linkify
                                  tagName="p"
                                  options={{
                                    attributes: {
                                      target: "_blank",
                                      rel: "noopener",
                                    },
                                    nl2br: true,
                                  }}
                                >
                                  {entry.jobDescription}
                                </Linkify>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                </div>
              ))}
            </div>
          </section>
        )
      }}
    />
  </Layout>
)

export default JobsPage
